import { Card, CardContent, CardHeader } from '@/components/ui/card';
import type { ReactNode } from 'react';

interface AuthLayoutProps {
  title: string;
  subtitle: string;
  children: ReactNode;
}

/**
 * Shared layout for authentication pages (Login, Register)
 * Features:
 * - Atlas logo
 * - Honeycomb background pattern
 * - Centered card with shadow
 * - Consistent styling across auth pages
 */
export function AuthLayout({ title, subtitle, children }: AuthLayoutProps) {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-[#d9d9d9] p-4">
      {/* Honeycomb background pattern */}
      <div
        className="absolute inset-0 opacity-25 mix-blend-soft-light"
        style={{
          backgroundImage: 'url(/assets/images/honeycomb-pattern.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      <Card className="relative z-10 w-full max-w-[493px] rounded-[30px] border-0 bg-white shadow-lg">
        <CardHeader className="pb-2 pt-8 text-center">
          {/* Atlas Logo */}
          <div className="mb-4 flex justify-center px-4">
            <img
              src="/assets/images/atlas-logo.png"
              alt="Atlas Restoration & Remodeling"
              className="h-auto w-full max-w-[305px]"
            />
          </div>

          {/* Title */}
          <h1 className="text-[32px] font-bold leading-normal" style={{ color: '#0a0a9e' }}>
            {title}
          </h1>

          {/* Subtitle */}
          <p className="text-[18px] font-medium text-black">
            {subtitle}
          </p>
        </CardHeader>

        <CardContent className="px-10 pb-8">
          {children}
        </CardContent>
      </Card>
    </div>
  );
}
